import React, { useState, useEffect } from 'react';
import { Alert, FormCheck, Modal, Spinner } from 'react-bootstrap';
import { HHIEButton } from '../../../utility/HHIEButton';

const servicesAndSolutions = { chr: false, dsm: false, referrals: false, notify: false };

export const CancelSubscriptions = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [currentServices, setCurrentServices] = useState({...servicesAndSolutions});
    const [checks, setChecks] = useState({...servicesAndSolutions});
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [resultMessage, setResultMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pendingRequestExists, setPending] = useState(false);

    useEffect(() => {
        setLoading(true);
        setPending(false);
        if (props.account.registrationType && props.account.registrationType.length !== 0) {
            var servicesStringSplit = props.account.registrationType.split(';');
            let servicesCopy = { ...servicesAndSolutions };
            for (var service of servicesStringSplit) {
                if (service === 'CHR') {
                    servicesCopy.chr = true;
                }
                else if (service === 'DSM') {
                    servicesCopy.dsm = true;
                }
                else if (service === 'Notify') {
                    servicesCopy.notify = true;
                }
                else if (service === 'Referrals') {
                    servicesCopy.referrals = true;
                }
            }
            setCurrentServices(servicesCopy);
        }

        fetch('api/registration/did-request-cancellation-services/' + props.account.id)
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        setLoading(false);
                    setPending(json.message);
                })
                .catch( (ex) => {
                    console.log("Error geting a response from json", ex);
                })
            })
            .catch((error) => {
                console.log("Error getting a response: ", error);
            });
    }, [props]);

    const SubmitCancellationRequest = async () => {
        setSubmitting(true);
        if // NO services are used by org, we do nothing. Else, we submit.
        (
            // Does org have AT LEAST one service?
            (currentServices.chr || currentServices.dsm || currentServices.notify || currentServices.referrals)
            && 
            // Is at least one check 'checked'?
            (checks.chr || checks.dsm || checks.notify || checks.referrals)
        )
        {
            const formData = new FormData();
            formData.append("chr", checks.chr);
            formData.append("dsm", checks.dsm);
            formData.append("notify", checks.notify);
            formData.append("referrals", checks.referrals);
            formData.append("accountId", props.account.id);
            formData.append("sfid", props.user.sfid);
            formData.append("isPOC", props.user.isPOCUser);
    
            const requestOptions = {
                method: 'POST',
                body: formData
            }
            const requestSuccessful = await fetch('api/registration/cancel-services-request', requestOptions)
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                }
                catch (ex) {
                    return console.log("cancel subscription exception for json", ex);
                }
            })
            .catch(ex => {
                console.log("cancel subscription exception for response", ex);
            });
            if (requestSuccessful) {
                setResultMessage("Your cancellation request has successfully been sent to the HHIE.");
                setSuccess(true);
                setError(false);
                setPending(true);
            }
            else {
                setResultMessage("Something went wrong. Please try again, or contact the HHIE.");
                setError(true);
                setSuccess(false);
                setPending(false);
            }
        }
        else 
        {
            setSuccess(false);
            setError(true);
            setResultMessage("No action was taken. You haven't checked any boxes, or your organization does not have any services.");
        }
        setSubmitting(false);
    }

    return (
        <>
        {pendingRequestExists ?
            <Alert 
                id="cancel-services-alert" 
                variant="danger"
                style={{
                    maxWidth: '275px'
                }}
            > 
                The HHIE are processing a Services & Solutions Cancellation Request
            </Alert>
            :
                <HHIEButton
                    disabled={loading}
                id="remove-services"
                variant="danger"
                size="sm"
                marginl={2}
                onClick={() => { 
                    setShowModal(true);  
                }}
                title={<strong>{"Cancel Subscriptions"}</strong>}
            />
        }
            
        <Modal
            show={showModal}
            size="lg"
            centered
            onHide={() => { 
                let pvarcopy = pendingRequestExists;
                setPending(pvarcopy);
                setChecks({...servicesAndSolutions});
                setResultMessage(null);
                setSubmitting(false);
                setSuccess(false);
                setError(false);
                setShowModal(false);
            }}
        >

            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Request Cancellation for Services/Solutions
                </Modal.Title>
            </Modal.Header>
            {(success || error)
            ?
                <Modal.Body>
                    <Alert
                        variant={(success) ? "success" : "warning"}>
                        {resultMessage}
                    </Alert>
                </Modal.Body>
            :
                <>
                <Modal.Body>
                    <p>
                        Select one or more of the following services/subscriptions you want to request to cancel. 
                    </p>

                    {currentServices.chr &&
                    <FormCheck
                        label="Community Health Record"
                        checked={checks.chr}
                        onChange={(e) => {
                            let checkCopy = {...checks};
                            checkCopy.chr = e.target.checked;
                            setChecks(checkCopy);
                        }}
                    />}
                    {currentServices.dsm &&
                    <FormCheck
                        label="Direct Secure Messaging"
                        checked={checks.dsm}
                        onChange={(e) => {
                            let checkCopy = {...checks};
                            checkCopy.dsm = e.target.checked;
                            setChecks(checkCopy);
                        }}
                    />}
                    {currentServices.referrals &&
                    <FormCheck
                        label="Referrals"
                        checked={checks.referrals}
                        onChange={(e) => {
                            let checkCopy = {...checks};
                            checkCopy.referrals = e.target.checked;
                            setChecks(checkCopy);
                        }}
                    />}
                    {currentServices.notify &&
                    <FormCheck
                        label="Notify"
                        checked={checks.notify}
                        onChange={(e) => {
                        let checkCopy = {...checks};
                        checkCopy.notify = e.target.checked;
                        setChecks(checkCopy);
                        }}
                    />}
                </Modal.Body>
                <Modal.Footer>
                    <HHIEButton
                        variant="warning" 
                        size="sm"
                        onClick={() => { SubmitCancellationRequest(); }}
                        title={!submitting 
                            ? "Submit Cancellation Request"
                            : <Spinner animation="border"/>
                        }
                    />
                </Modal.Footer>
                </>
            }
        </Modal>          
    </>
    );
}
